module.exports = __webpack_public_path__ + "static/media/answerselect.498200d6.png";